import type { IFormilySchema } from '../types';
import {
  isFormComponent,
  isArrayTableComponent,
  isFlowChartComponent,
} from './findFormComponent';

const hasReactionsInTree = (field: any): boolean => {
  if (!field || typeof field !== 'object') return false;
  if (field['x-reactions']) return true;
  if (field.properties) {
    return Object.values(field.properties).some(hasReactionsInTree);
  }
  return false;
};

const processField = (field: any): any => {
  if (!field) return field;

  const shouldSkip =
    field['x-reactions'] ||
    isFormComponent(field) ||
    isArrayTableComponent(field) ||
    isFlowChartComponent(field) ||
    (field.properties && hasReactionsInTree(field));

  if (shouldSkip) return field;

  let needsClone = false;
  let newValidators = field['x-validator'];

  if (field.required === true) {
    const validators = Array.isArray(field['x-validator'])
      ? field['x-validator']
      : [];
    const hasRequired = validators.some(
      (v: any) => v === 'required' || v?.required === true
    );
    if (!hasRequired) {
      newValidators = [...validators, 'required'];
      needsClone = true;
    }
  }

  let newProperties = field.properties;
  if (field.properties) {
    const processedEntries = Object.entries(field.properties).map(
      ([key, value]) => {
        const processed = processField(value);
        if (processed !== value) needsClone = true;
        return [key, processed];
      }
    );
    if (needsClone) {
      newProperties = Object.fromEntries(processedEntries);
    }
  }

  if (!needsClone) return field;

  return {
    ...field,
    'x-validator': newValidators,
    ...(newProperties !== field.properties && { properties: newProperties }),
  };
};

export const injectRequiredValidators = (
  schema: IFormilySchema
): IFormilySchema => {
  if (!schema) return schema;
  return processField(schema) as IFormilySchema;
};
